import * as fabric from "fabric";
import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import layoutHorizontal from "../data/layoutHorizontal.json";
import layoutSquare from "../data/layoutSquare.json";
import layoutVertical from "../data/layoutVertical.json";
import { useAppDispatch, useAppSelector } from "../hook/redux";
import Template from "./Template";
import Toolbar from "./Toolbar/Toolbar";
import {
  addEditorEventListeners,
  exportLayout,
  extendFabricToObject,
  fetchExistingCard,
  handleEditorViewport
} from "./utils";
import fakeData from "../data/fakeData.json";
import fakeDataPolaroid from "../data/fakeDataPolaroid.json";
import FontFaceObserver from 'fontfaceobserver';
import fontsData from '../assets/fonts.json'; // Assurez-vous que le chemin est correct



extendFabricToObject();

export default function Editor() {
  const {
    selectedLayout,
    currentData,
    layouts,
    selectedBackground,
    isExportable,
    existingData,
    isLoading,
  } = useAppSelector((state) => state.editor);

  const [layout, setLayout] = useState(
    layouts.find((layout) => layout.id === selectedLayout)
  );
  const [top, setTop] = useState(0);
  const [fontsIsLoading, setFontsIsLoading] = useState(true);
  const [dataIsLoading, setDataIsLoading] = useState(true);

  const fabricCanvasInstanceRef = useRef<fabric.Canvas | null>(null);

  const resolvePreloadCard = (orient: string): string =>
    window.initialDatas && window.initialDatas.backgroundCard
      ? window.initialDatas.backgroundCard
      : selectedBackground[orient]?.value;

  const orient =
    window.initialDatas?.orient ??
    (window.location.pathname.includes("-h")
      ? "h"
      : window.location.pathname.includes("-s")
      ? "s"
      : "v");
  // const orient = "s"

  //TODO :  ExistingData ?
  const preloadCard = resolvePreloadCard(orient);
  const uid =
    window.initialDatas?.uid || "28807aca-8ef5-42ee-ab03-54eb9d218318";
  const prevPage = window.initialDatas?.prevPage || "";
  const carteId = window.initialDatas?.cardId || "";
  const page = window.initialDatas?.page || 1;

  const photoId = "";
  const elementHeight = window.innerWidth > 576 ? 100 : 85;

  const dispatch = useAppDispatch();
  const useFakeData = false; // Set to true to use fake data for testing purposes

  /**
   * This `useEffect` intercepts the `console.log` method to display log messages
   * directly on the screen in a floating overlay. This is useful for debugging
   * in environments where access to the developer console is limited (IOS)
   *
   * The overlay displays logs in real-time at the bottom of the page.
   */
  // useEffect(() => {
  //   const logInOverlay = enableDebugConsoleOverlay()
  //
  //   return logInOverlay
  // }, []);

  useEffect(() => addEditorEventListeners(), []);
  useEffect(() => handleEditorViewport(setTop), []);

  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      const url = `${process.env.PREFIX_URL}/v2017/ajax/ajax.php?traitement=get-card-multimg-v2`;

      const fetchData = async () => {
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          let data = await response.json();
          console.log("API Data:", data);
          if (
            data.data.success &&
            data.data.paramGeneral &&
            data.data.paramGeneral.carteId !== carteId
          ) {
            console.log("Carte ID mismatch, fetching new data...");
            data = {
              data: {
                success: false,
              },
            };
            console.log("New data:", data);
          }

          await dispatch({
            type: "editor/updateExistingData",
            payload: data,
          });

          dispatch({
            type: "editor/updateIsLoading",
            payload: false,
          });
        } catch (error) {
          console.error("Erreur lors de la récupération des données:", error);
        }
      };

      fetchData();
    }
  }, [dispatch]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (useFakeData && fakeDataPolaroid) {
  // dispatch( {
  //   type: "editor/updateIsLoading",
  //   payload: true,
  // } );
  //       await dispatch({
  //         type: "editor/updateExistingData",
  //         payload: fakeDataPolaroid,
  //       });
  // dispatch( {
  //   type: "editor/updateIsLoading",
  //   payload: false,
  // } );
  //     }
  //   };

  //   fetchData();
  // }, [useFakeData, fakeData, dispatch]);

  useEffect(() => {
    if (
      existingData &&
      existingData.data &&
      existingData.data.paramGeneral &&
      existingData.data.paramGeneral.bgColor &&
      preloadCard &&
      orient
    ) {
      dispatch({
        type: "editor/updateSelectedBackground",
        payload: {
          type: existingData.data.paramGeneral.bgColorType,
          value: existingData.data.paramGeneral.bgColor,
          index: 0,
          orientation: orient,
        },
      });
    } else if (!existingData && preloadCard && orient) {
      dispatch({
        type: "editor/updateSelectedBackground",
        payload: {
          type:
            window.initialDatas && window.initialDatas.backgroundCard
              ? "image"
              : selectedBackground[orient].type,
          value: preloadCard,
          index: 0,
          orientation: orient,
        },
      });
    }

    if (
      window.location.hostname !== "localhost" &&
      existingData &&
      existingData.data &&
      existingData.data.success &&
      existingData.data.dataTxtCard &&
      existingData.data.dataTxtCard
    ) {
      existingData.data.dataTxtCard.forEach((textbox) => {
        dispatch({
          type: "editor/updateTextsData",
          payload: {
            index: textbox.index,
            value: textbox.value,
            layout: selectedLayout,
            properties: {
              textVAlign: textbox.properties.textVAlign,
              textAlign: textbox.properties.textAlign,
              textFont: textbox.properties.textFont,
              textFontFamily: textbox.properties.textFontFamily,
              textFontColor: textbox.properties.textFontColor,
              textFontSize: textbox.properties.textFontSize,
              textFontColorType: textbox.properties.textFontColorType,
            },
          },
        });
      });
      setDataIsLoading(false);
    } else if (
      window.location.hostname === "localhost" ||
      (existingData && existingData.data && !existingData.data.success)
    ) {
      setDataIsLoading(false);
    }

    const layoutData =
      window.initialDatas?.layouts ||
      (orient === "v"
        ? layoutVertical
        : orient === "h"
        ? layoutHorizontal
        : layoutSquare);

    dispatch({
      type: "editor/updateLayouts",
      payload: {
        orient,
        preloadCard:
          existingData &&
          existingData.data.paramGeneral &&
          existingData.data.paramGeneral.bgColor
            ? existingData.data.paramGeneral.bgColor
            : preloadCard,
        carteId,
        photoId,
      },
    });

    dispatch({
      type: "editor/addLayoutData",
      payload: layoutData,
    });
  }, [orient, existingData]);

  useEffect(() => {
    if (layouts.length > 0) {
      dispatch({
        type: "editor/updateSelectedLayout",
        payload:
          existingData &&
          existingData.data.paramGeneral &&
          existingData.data.paramGeneral.layoutId
            ? existingData.data.paramGeneral.layoutId
            : useFakeData && fakeData
            ? fakeData.data.paramGeneral.layoutId
            : layouts[0].id,
      });
    }
  }, [layouts, existingData]);

  useEffect(() => {
    if (selectedLayout) {
      setLayout(layouts.find((layout) => layout.id === selectedLayout));
    }
  }, [selectedLayout]);

  useEffect(() => {
    if (layout) {
      const fetchData = async () => {
        try {
          const isEnabled = (feature: string) =>
            layout.enabled?.includes(feature);
          const isRounded = !layout.disabled?.includes("roundedCoin");

          const paramGeneral = {
            layoutId: selectedLayout,
            uid: uid,
            prevPage: prevPage,
            page: page ? page : 1,
            isRounded,
            isQRCode: isEnabled("qrCode") ? true : false,
            isTextGenerator: isEnabled("textGenerator") ? true : false,
            isSignature: isEnabled("signature") ? true : false,
            carteId,
            orient: orient,
          };

          if (
            process.env.NODE_ENV === "development" ||
            window.location.hostname === "localhost" ||
            "goldfish-app-4gnas.ondigitalocean.app"
          ) {
            dispatch({
              type: "editor/updateCurrentData",
              payload: { paramGeneral },
            });
          } else if (window.location.hostname === process.env.PREFIX_URL) {
            await fetchExistingCard();
            dispatch({
              type: "editor/updateCurrentData",
              payload: { paramGeneral },
            });
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des données:", error);
        }
      };
      fetchData();
    }
  }, [layout]);

  useEffect(() => {
    const fontFaceObservers = fontsData.fonts.map(
      (font) => new FontFaceObserver(font)
    );

    Promise.all(fontFaceObservers.map((observer) => observer.load()))
      .then(() => {
        setFontsIsLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des polices:", error);
        setFontsIsLoading(false);
      });
  }, []);

  /**
   * Asynchronous function to handle the export process for a given layout.
   *
   * The function first checks whether the export operation is permissible by evaluating
   * the `isExportable` flag. If the flag is set to false, the function exits early without
   * performing any operation. When the export is initiated, it sets a loading state to true,
   * executes the `exportLayout` operation, and manages errors, if any occur during the process.
   * Finally, it resets the loading state to false after the operation is completed.
   *
   * The export operation relies on the provided canvas instance (`fabricCanvasInstanceRef`)
   * and orientation (`orient`) to generate the layout.
   */
  const handleExport = async () => {
    if (!isExportable) return;

    dispatch({
      type: "editor/updateIsLoading",
      payload: true,
    });
    try {
      const response = await exportLayout(fabricCanvasInstanceRef);

      if (response.success && response.nextPage) {
        window.location.href = response.nextPage;
      }
    } catch (error) {
      console.error("Erreur pendant l'export :", error);
    } finally {
      dispatch({
        type: "editor/updateIsLoading",
        payload: false,
      });
    }
  };

  return (
    <>
      {isLoading && (
        <div
          className={"position-absolute top-50 start-50 translate-middle"}
          style={{ zIndex: 9999 }}
        >
          <i
            className="fad fa-spinner spinner-animation"
            aria-hidden="true"
            style={{
              margin: "0",
              position: "absolute",
              top: "calc(50% - 40px)",
              left: "calc(50% - 40px)",
              transform: "translate(-50%, -50%)",
              color: "#4498E0",
              fontSize: "80px",
            }}
          ></i>
        </div>
      )}
      <div
        className="personalize-bar d-flex flex-column flex-md-row justify-content-between align-items-center p-2 bg-white position-relative"
        style={{ zIndex: 1000 }}
      >
        {window.innerWidth > 576 && (
          <p
            style={{ fontSize: "25px", fontWeight: "600", color: "#585454" }}
            className="text-center text-md-start mb-1"
          >
            Personnalisez votre carte
          </p>
        )}
        <div className="d-flex gap-2 mt-1 mt-md-0">
          <div
            className="btn custom-button-outline"
            onClick={() => {
              if (window.initialDatas && window.initialDatas.prevPage) {
                window.location.href = window.initialDatas.prevPage;
              } else {
                window.history.go(-1);
              }
            }}
          >
            <i
              className="fa fa-arrow-circle-left"
              aria-hidden="true"
              style={{ color: "#7d59ff", fontSize: "22px" }}
            ></i>
          </div>

          <div
            className={`btn custom-button ${
              !isExportable || isLoading ? "disabled" : ""
            }`}
            style={{ fontSize: "18px" }}
            onClick={handleExport}
          >
            <span>Etape suivante</span>
            <i
              className="fa fa-arrow-circle-right"
              aria-hidden="true"
              style={{ color: "#ffffff", fontSize: "22px" }}
            ></i>
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-column-reverse flex-md-row-reverse h-md-75"
        style={isLoading ? { filter: "blur(5px)" } : {}}
      >
        <Container
          id="global-container"
          className={`global-container d-flex flex-column justify-content-between bg-light p-3 flex-md-row`}
        >
          <div className="w-100 h-100">
            <div
              id={"container"}
              className="w-100 h-100 order-1 order-sm-2 d-sm-flex flex-sm-column justify-content-sm-center align-items-sm-center vh-sm-80"
              data-test={"container"}
            >
              {!fontsIsLoading &&
                !dataIsLoading &&
                currentData.paramGeneral.orient && (
                  <Template fabricCanvasInstanceRef={fabricCanvasInstanceRef} />
                )}
            </div>
          </div>
        </Container>
        <div
          className="bottom-0 left-0 z-index-5 d-none d-md-block rounded pt-4 h-md-100"
          style={{ width: "120px" }}
        >
          <Toolbar canvas={fabricCanvasInstanceRef} />
        </div>
        <div
          className={`position-sticky w-100 z-index-5 d-md-none mb-2`}
          style={{
            height: `${elementHeight}px`,
            top: `${top}px`,
            zIndex: 1000,
          }}
        >
          <Toolbar canvas={fabricCanvasInstanceRef} />
        </div>
      </div>
    </>
  );
}
